import { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import Accordion from "@mui/material/Accordion";

import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Unstable_Grid2";
import { Filter } from "@solar-icons/react/ssr";

import { selectPersonId } from "@/auth/authSlice";
import CsvExportButton from "@/common/CsvExportButton";
import { Heading } from "@/common/typography";
import CustomFiltersDropdown from "@/table/CustomFiltersDropdown";
import CustomFiltersSavePopup from "@/table/CustomFiltersSavePopup";

export default function CustomFilters(props) {
    const {
        title,
        modelType,
        filterComponents,
        filters,
        setFilters,
        order,
        setOrder,
        defaultOrder,
        customFilters,
        setCustomFilters,
        activeCustomFilter,
        setActiveCustomFilter,
    } = props;
    const Filters = useMemo(() => filterComponents, []);
    const [expanded, setExpanded] = useState(false);
    const personId = useSelector(selectPersonId);

    const handleExpanded = (event, value) => {
        setExpanded(value);
    };

    const handleInputChange = (filterName) => (event) => {
        setFilters({ ...filters, [filterName]: "like:" + event.target.value });
    };

    const handleAutocompleteChange = (filterName) => (event, newValue) => {
        if (newValue) {
            setFilters({ ...filters, [filterName]: "eq:" + newValue });
        }
    };

    const handleAutocompleteClear =
        (filterName) => (event, newValue, reason) => {
            if (reason == "clear") {
                const newFilters = { ...filters };
                delete newFilters[filterName];
                setFilters(newFilters);
            }
        };

    return (
        <>
            <Accordion
                sx={{
                    background: "transparent",
                    boxShadow: "none",
                    marginBottom: "12px",
                    "&::before": { content: "unset" },
                }}
                expanded={expanded}
                onChange={handleExpanded}
            >
                <AccordionSummary
                    expandIcon={
                        <Badge
                            color="primary"
                            variant="dot"
                            invisible={Object.keys(filters).length == 0}
                            anchorOrigin={
                                expanded
                                    ? {
                                          vertical: "bottom",
                                          horizontal: "left",
                                      }
                                    : {
                                          vertical: "top",
                                          horizontal: "right",
                                      }
                            }
                        >
                            <IconButton
                                size="small"
                                sx={{ background: "#ffffff22" }}
                            >
                                <Filter />
                            </IconButton>
                        </Badge>
                    }
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    sx={{ padding: 0 }}
                >
                    <Heading>{title}</Heading>
                </AccordionSummary>

                <AccordionDetails sx={{ padding: "8px 0" }}>
                    <CustomFiltersDropdown
                        modelType={modelType}
                        setFilters={setFilters}
                        defaultOrder={defaultOrder}
                        setOrder={setOrder}
                        customFilters={customFilters}
                        setCustomFilters={setCustomFilters}
                        activeCustomFilter={activeCustomFilter}
                        setActiveCustomFilter={setActiveCustomFilter}
                    />

                    <Filters
                        filters={filters}
                        setFilters={setFilters}
                        handleInputChange={handleInputChange}
                        handleAutocompleteChange={handleAutocompleteChange}
                        handleAutocompleteClear={handleAutocompleteClear}
                    />

                    <Grid sx={{ paddingTop: 2 }}>
                        <CustomFiltersSavePopup
                            customFilters={customFilters}
                            setCustomFilters={setCustomFilters}
                            setActiveCustomFilter={setActiveCustomFilter}
                            filters={filters}
                            orders={order}
                            personId={personId}
                            modelType={modelType}
                        />
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    );
}
